var map = {
	"./audios/MRI-ExemploA.mp3": "0f73",
	"./audios/MRI-ExemploB.mp3": "adb5",
	"./audios/MRI-ExemploC.mp3": "c991",
	"./audios/MRI-exemplo-ad.mp3": "e4b7",
	"./audios/MRI-exemplo.mp3": "b0cf",
	"./audios/MRI1-ad.mp3": "3f71",
	"./audios/MRI1.mp3": "92bb",
	"./audios/MRI10-ad.mp3": "811f",
	"./audios/MRI10.mp3": "f0a7",
	"./audios/MRI10A.mp3": "233f",
	"./audios/MRI10B.mp3": "795d",
	"./audios/MRI10C.mp3": "5250",
	"./audios/MRI11-ad.mp3": "34dc",
	"./audios/MRI11.mp3": "d07f",
	"./audios/MRI11A.mp3": "86ef",
	"./audios/MRI11B.mp3": "652b",
	"./audios/MRI11C.mp3": "d1a5",
	"./audios/MRI12-ad.mp3": "a122",
	"./audios/MRI12.mp3": "2edc",
	"./audios/MRI12A.mp3": "aab9",
	"./audios/MRI12B.mp3": "b2c7",
	"./audios/MRI12C.mp3": "c353",
	"./audios/MRI13-ad.mp3": "b79e",
	"./audios/MRI13.mp3": "820c",
	"./audios/MRI13A.mp3": "b66f",
	"./audios/MRI13B.mp3": "d89d",
	"./audios/MRI13C.mp3": "fbbf",
	"./audios/MRI14-ad.mp3": "82b2",
	"./audios/MRI14.mp3": "c570",
	"./audios/MRI14A.mp3": "68ed",
	"./audios/MRI14B.mp3": "833b",
	"./audios/MRI14C.mp3": "a4d9",
	"./audios/MRI15-ad.mp3": "f6da",
	"./audios/MRI15.mp3": "eb21",
	"./audios/MRI15A.mp3": "4f19",
	"./audios/MRI15B.mp3": "0b9f",
	"./audios/MRI15C.mp3": "0706",
	"./audios/MRI16-ad.mp3": "31a6",
	"./audios/MRI16.mp3": "0c06",
	"./audios/MRI16A.mp3": "0d50",
	"./audios/MRI16B.mp3": "c9dd",
	"./audios/MRI16C.mp3": "4f67",
	"./audios/MRI17-ad.mp3": "6a55",
	"./audios/MRI17.mp3": "65be",
	"./audios/MRI17A.mp3": "ade9",
	"./audios/MRI17B.mp3": "3732",
	"./audios/MRI17C.mp3": "afbd",
	"./audios/MRI18-ad.mp3": "b363",
	"./audios/MRI18.mp3": "e061",
	"./audios/MRI18A.mp3": "1868",
	"./audios/MRI18B.mp3": "d994",
	"./audios/MRI18C 2.mp3": "645d",
	"./audios/MRI18C.mp3": "a687",
	"./audios/MRI19-ad.mp3": "22ba",
	"./audios/MRI19.mp3": "d851",
	"./audios/MRI19A.mp3": "e81f",
	"./audios/MRI19B.mp3": "859b",
	"./audios/MRI19C.mp3": "0056",
	"./audios/MRI1A.mp3": "812a",
	"./audios/MRI1B.mp3": "7471",
	"./audios/MRI1C.mp3": "d6fc",
	"./audios/MRI2-ad.mp3": "12dd",
	"./audios/MRI2.mp3": "4223",
	"./audios/MRI20-ad.mp3": "6392",
	"./audios/MRI20.mp3": "dea0",
	"./audios/MRI20A.mp3": "b476",
	"./audios/MRI20B.mp3": "6c3a",
	"./audios/MRI20C.mp3": "fa30",
	"./audios/MRI21-ad.mp3": "a8af",
	"./audios/MRI21.mp3": "0ffc",
	"./audios/MRI21A.mp3": "1bf9",
	"./audios/MRI21B.mp3": "8af3",
	"./audios/MRI21C.mp3": "18a2",
	"./audios/MRI22-ad.mp3": "c581",
	"./audios/MRI22.mp3": "982c",
	"./audios/MRI22A.mp3": "cdf6",
	"./audios/MRI22B.mp3": "82c9",
	"./audios/MRI22C.mp3": "dd6a",
	"./audios/MRI2A.mp3": "5716",
	"./audios/MRI2B.mp3": "368c",
	"./audios/MRI2C.mp3": "fcb3",
	"./audios/MRI3-ad.mp3": "3b15",
	"./audios/MRI3.mp3": "c15c",
	"./audios/MRI3A.mp3": "7a4d",
	"./audios/MRI3B.mp3": "2978",
	"./audios/MRI3C.mp3": "387f",
	"./audios/MRI4-ad.mp3": "3d42",
	"./audios/MRI4.mp3": "f3cd",
	"./audios/MRI4A.mp3": "ed99",
	"./audios/MRI4B.mp3": "1d0a",
	"./audios/MRI4C.mp3": "e6f8",
	"./audios/MRI5-ad.mp3": "d2b3",
	"./audios/MRI5.mp3": "a750",
	"./audios/MRI5A.mp3": "b5f7",
	"./audios/MRI5B.mp3": "15e2",
	"./audios/MRI5C.mp3": "ee0b",
	"./audios/MRI6-ad.mp3": "e15b",
	"./audios/MRI6.mp3": "210d",
	"./audios/MRI6A.mp3": "bb91",
	"./audios/MRI6B.mp3": "ee0e",
	"./audios/MRI6C.mp3": "026f",
	"./audios/MRI7-ad.mp3": "26ca",
	"./audios/MRI7.mp3": "3331",
	"./audios/MRI7A.mp3": "3ddf",
	"./audios/MRI7B.mp3": "9018",
	"./audios/MRI7C.mp3": "bdd6",
	"./audios/MRI8-ad.mp3": "60ec",
	"./audios/MRI8.mp3": "977f",
	"./audios/MRI8A.mp3": "9385",
	"./audios/MRI8B.mp3": "58d5",
	"./audios/MRI8C.mp3": "0c9f",
	"./audios/MRI9-ad.mp3": "1f83",
	"./audios/MRI9.mp3": "d09d",
	"./audios/MRI9A.mp3": "8558",
	"./audios/MRI9B.mp3": "ad97",
	"./audios/MRI9C.mp3": "0ef3",
	"./end-button.jpg": "a385",
	"./exemplo.jpg": "56f2",
	"./historia1.jpg": "aa65",
	"./historia10.jpg": "0668",
	"./historia11.jpg": "a52b",
	"./historia12.jpg": "a065",
	"./historia13.jpg": "645df",
	"./historia14.jpg": "0140",
	"./historia15.jpg": "61ac",
	"./historia16.jpg": "6d44",
	"./historia17.jpg": "39ba",
	"./historia18.jpg": "46bf",
	"./historia19.jpg": "50bc",
	"./historia2.jpg": "d3ec",
	"./historia20.jpg": "bc05",
	"./historia21.jpg": "fe91",
	"./historia22.jpg": "b2cc",
	"./historia3.jpg": "f199",
	"./historia4.jpg": "40b0",
	"./historia5.jpg": "603a",
	"./historia6.jpg": "2c4b",
	"./historia7.jpg": "4cef",
	"./historia8.jpg": "9720",
	"./historia9.jpg": "7ba2",
	"./home.jpg": "3881",
	"./next-icon.jpg": "211e",
	"./prev-icon.jpg": "6308",
	"./sound-icon.jpg": "07c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";